export type { M61USPProps } from './M61USP';
export { M61USP } from './M61USP';
export { M61USP as default } from './M61USP';
